module.exports = __webpack_public_path__ + "static/media/steg-min.8460b41f.png";